<template>
  <div>
    <div
      class="pb-1"
      v-bind:style="{
        color: color(
          checkin.talkingPointCount,
          false,
          overrideColor || $vuetify.theme.themes.light.performance
        )
      }"
    >
      <v-avatar
        size="20"
        :color="
          color(
            checkin.talkingPointCount,
            true,
            overrideColor || $vuetify.theme.themes.light.performance
          )
        "
      >
        {{ checkin.talkingPointCount }}
      </v-avatar>
      <span class="mx-1">
        Talking Points
      </span>
      <v-icon v-if="checkin.hasUrgentTalkingPoint" color="error" small>
        error
      </v-icon>
    </div>
    <div
      class="pb-1"
      v-bind:style="{
        color: color(
          checkin.actionItemCount,
          false,
          overrideColor || $vuetify.theme.themes.light.info
        )
      }"
    >
      <v-avatar
        size="20"
        :color="
          color(
            checkin.actionItemCount,
            true,
            overrideColor || $vuetify.theme.themes.light.info
          )
        "
      >
        {{ checkin.actionItemCount }}
      </v-avatar>
      <span class="mx-1">
        Action Items
      </span>
      <v-icon v-if="checkin.pastDueActionItems > 0" color="error" small>
        error
      </v-icon>
    </div>
    <div
      v-bind:style="{
        color: color(
          checkin.goalCount,
          false,
          overrideColor || $vuetify.theme.themes.light.success
        )
      }"
      v-if="checkin.goalCount != null && settings.isGoalsActive"
    >
      <v-avatar
        size="20"
        :color="
          color(
            checkin.goalCount,
            true,
            overrideColor || $vuetify.theme.themes.light.success
          )
        "
      >
        {{ checkin.goalCount }}
      </v-avatar>
      <span class="mx-1">
        Goals
      </span>
      <v-icon v-if="checkin.pastDueGoals > 0" color="error" small>
        error
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CheckInLabels",
  props: {
    checkin: { type: Object },
    overrideColor: { type: String }
  },
  computed: {
    color() {
      return (count, isBackground, color) => {
        let opacity = 1;
        if (isBackground) {
          opacity = count ? 0.1 : 0;
        } else {
          opacity = count ? 1 : 0.2;
        }
        return this.getColor(color, opacity);
      };
    },
    ...mapGetters({ settings: "profile/settings" })
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-badge__badge {
  min-width: 14px;
  height: 14px;
  padding: 0;
  inset: auto auto calc(100% - 8px) calc(100% - 8px) !important;

  .v-icon {
    font-size: 10px;
  }
}
</style>
